import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: '/:conferenceId/:type',
    name: 'conferenceBase',
    component: () => import('@/components/HelloWorld'),
    meta: {
      title: 'routeTitle.understandChina',
      affix: true
    },
    children: [
      {
        path: "",
        component: () => import('@/views/index'),
        meta: {
          title: 'routeTitle.understandChina',
          affix: true
        },
        children: [{
          path: 'login',
          component: () => import('@/views/login'),
          meta: {
            title: 'routeTitle.login',
            affix: true
          },
        }, {
          path: 'setPassword',
          component: () => import('@/views/setPassword'),
          meta: {
            title: 'routeTitle.login',
            affix: true
          },
        }]
      },
      {
        path: 'guestInfo',
        component: () => import('@/views/guestInfo'),
        name: 'guestInfo',
        meta: {
          title: 'routeTitle.improve',
          affix: true
        }
      },
      {
        path: 'personal',
        component: () => import('@/views/personalPage'),
        meta: {
          title: 'routeTitle.personal',
          affix: true
        },
      },
      {
        path: 'notify',
        component: () => import('@/views/notify'),
        meta: {
          title: 'routeTitle.notify',
          affix: true
        },
      },
      {
        path: 'notify/:id',
        component: () => import('@/views/notify/detail'),
        meta: {
          title: 'routeTitle.notify',
          affix: true
        },
      },
      {
        path: 'setting',
        component: () => import('@/views/setting'),
        meta: {
          title: 'routeTitle.setting',
          affix: true
        },
      },
      {
        path: 'changePassword',
        component: () => import('@/views/setting/changePassword'),
        meta: {
          title: 'routeTitle.changePassword',
          affix: true
        },
      },
      {
        path: 'guestConfirm',
        component: () => import('@/views/guestInfo/infoComplete'),
        meta: {
          title: 'routeTitle.confirm',
          affix: true
        },
      },
      {
        path: 'mediaConfirm',
        component: () => import('@/views/media/infoComplete'),
        meta: {
          title: 'routeTitle.confirm',
          affix: true
        },
      },
      {
        path: 'mediaSuccess',
        component: () => import('@/views/media/infoSuccessComplete'),
        meta: {
          title: 'routeTitle.confirm',
          affix: true
        },
      },
      {
        path: 'media',
        component: () => import('@/views/mediaInfo'),
        name: 'media',
        meta: {
          title: 'routeTitle.improve',
          affix: true
        }
      },
      {
        path: 'staff',
        component: () => import('@/views/staffRegis'),
        name: 'staff',
        meta: {
          title: 'routeTitle.improve',
          affix: true
        }
      },
      {
        path: 'guangzhou',
        component: () => import('@/views/guangzhouRegis'),
        name: 'guangzhou',
        meta: {
          title: 'routeTitle.improve',
          affix: true
        }
      },
      {
        path: 'payment',
        component: () => import('@/views/paymentRegis'),
        name: 'payment',
        meta: {
          title: 'routeTitle.improve',
          affix: true
        }
      },
      {
        path: '*',
        redirect: 'login'
      }
    ]
  }
];

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach((to, from, next) => {
  if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    window.location.href = window.location.href.replace('/vsite/', '/vsite-pc/')
    console.log(window.location.href)
    return
  }
  next()
})

export default router;
